module.exports = __webpack_public_path__ + "images/8f5425a4632d60fb44322dbcffc929b8.jpg";